import { globalState } from '../models';

export const tracker = (evt: string, ext?: Record<string, any> | string) => {
    if (globalState.tracker) {
        globalState.tracker(evt, ext);
    }
};
